import { render, staticRenderFns } from "./MobileQueryOrder.vue?vue&type=template&id=1d5ec508&scoped=true"
import script from "./MobileQueryOrder.vue?vue&type=script&lang=js"
export * from "./MobileQueryOrder.vue?vue&type=script&lang=js"
import style0 from "./MobileQueryOrder.vue?vue&type=style&index=0&id=1d5ec508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5ec508",
  null
  
)

export default component.exports